/* FOODHUB Journal — filter v12 (URL state + share button) */
(function () {
  if (window.__fhBlogFilterV12) return;
  window.__fhBlogFilterV12 = true;

  var STYLE = '.fh-hide-during-search{display:none !important}' +
    '.fh-toolbar{display:flex !important;align-items:center !important;gap:24px !important;flex-wrap:wrap !important;border-bottom:1px solid #ececec;padding-bottom:18px;margin-bottom:24px}' +
    '.fh-toolbar .fh-pills{flex:1;min-width:0}' +
    '.fh-toolbar .fh-search-cell{display:flex !important;align-items:center !important;gap:8px !important;position:relative !important}' +
    '.fh-toolbar .fh-search,.foodhub-journal .fh-search{position:relative !important;flex:0 0 auto !important;margin:0 !important;padding:0 !important;background:transparent !important;border:0 !important;border-radius:0 !important;box-shadow:none !important;width:280px !important;max-width:100% !important;height:auto !important;min-height:0 !important}' +
    '.fh-toolbar .fh-search::before,.foodhub-journal .fh-search::before{content:"";position:absolute;left:16px;top:50%;width:14px;height:14px;transform:translateY(-50%);background-image:url("data:image/svg+xml;utf8,<svg xmlns=\u0027http://www.w3.org/2000/svg\u0027 viewBox=\u00270 0 24 24\u0027 fill=\u0027none\u0027 stroke=\u0027%23555\u0027 stroke-width=\u00272\u0027 stroke-linecap=\u0027round\u0027 stroke-linejoin=\u0027round\u0027><circle cx=\u002711\u0027 cy=\u002711\u0027 r=\u00278\u0027/><line x1=\u002721\u0027 y1=\u002721\u0027 x2=\u002716.65\u0027 y2=\u002716.65\u0027/></svg>");background-repeat:no-repeat;background-size:contain;pointer-events:none;z-index:2}' +
    '.fh-toolbar .fh-search > svg,.fh-toolbar .fh-search > .fh-search-icon,.foodhub-journal .fh-search > svg{display:none !important}' +
    '#fh-search-input,.foodhub-journal #fh-search-input{width:100% !important;height:42px !important;padding:0 38px 0 40px !important;background:#f6f6f6 !important;border:0 !important;border-radius:100px !important;font-family:"Poppins","Inter",system-ui,sans-serif !important;font-size:13px !important;font-weight:400 !important;color:#161616 !important;letter-spacing:.2px !important;outline:none !important;transition:background .15s ease,box-shadow .15s ease !important;box-shadow:none !important;margin:0 !important;display:block !important}' +
    '#fh-search-input::placeholder{color:#888 !important;font-style:normal !important;letter-spacing:.2px !important;font-size:12px !important}' +
    '#fh-search-input:hover{background:#efefef !important}' +
    '#fh-search-input:focus,#fh-search-input:focus-visible{background:#fff !important;box-shadow:0 0 0 1px #161616, 0 0 0 4px rgba(22,22,22,.06) !important}' +
    '.fh-search .fh-search-clear{position:absolute !important;right:12px !important;top:50% !important;transform:translateY(-50%) !important;width:22px !important;height:22px !important;display:none;align-items:center !important;justify-content:center !important;background:#dcdcdc !important;border:none !important;border-radius:50% !important;color:#fff !important;font-size:14px !important;font-weight:600 !important;line-height:1 !important;cursor:pointer !important;padding:0 !important;font-family:Arial,sans-serif !important;transition:background .12s ease !important;z-index:3}' +
    '.fh-search .fh-search-clear:hover{background:#161616 !important;color:#fff !important}' +
    '.fh-share-btn{display:none;align-items:center !important;justify-content:center !important;width:42px !important;height:42px !important;border-radius:50% !important;background:#f6f6f6 !important;border:0 !important;cursor:pointer !important;padding:0 !important;color:#161616 !important;transition:background .15s ease !important;position:relative !important}' +
    '.fh-share-btn:hover{background:#161616 !important;color:#fff !important}' +
    '.fh-share-btn.is-visible{display:inline-flex !important}' +
    '.fh-share-btn svg{width:16px;height:16px}' +
    '.fh-share-pop{position:absolute !important;top:52px !important;right:0 !important;width:320px !important;background:#fff !important;border:1px solid #ececec !important;border-radius:12px !important;box-shadow:0 12px 32px rgba(0,0,0,.12) !important;padding:16px !important;z-index:1000;display:none;font-family:"Poppins","Inter",system-ui,sans-serif}' +
    '.fh-share-pop.is-open{display:block !important}' +
    '.fh-share-pop h4{font-size:12px !important;font-weight:600 !important;letter-spacing:.5px !important;text-transform:uppercase !important;color:#161616 !important;margin:0 0 10px !important}' +
    '.fh-share-row{display:flex;gap:6px;margin-bottom:12px}' +
    '.fh-share-row input{flex:1;height:36px;padding:0 12px;background:#f6f6f6;border:0;border-radius:6px;font-size:12px;color:#161616;font-family:inherit;outline:none}' +
    '.fh-share-row button{height:36px;padding:0 14px;background:#161616;border:0;border-radius:6px;color:#fff;font-size:11px;letter-spacing:.5px;text-transform:uppercase;font-weight:600;cursor:pointer;font-family:inherit;transition:background .12s}' +
    '.fh-share-row button:hover{background:#333}' +
    '.fh-share-row button.copied{background:#0a8556}' +
    '.fh-share-socials{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}' +
    '.fh-share-socials a{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;padding:10px 4px;background:#f6f6f6;border-radius:8px;text-decoration:none;color:#161616;font-size:10px;letter-spacing:.3px;transition:background .12s}' +
    '.fh-share-socials a:hover{background:#ececec}' +
    '.fh-share-socials svg{width:18px;height:18px}' +
    '@media (max-width:768px){.fh-toolbar{flex-direction:column !important;align-items:stretch !important;gap:14px !important;padding-bottom:14px}.fh-toolbar .fh-search-cell{width:100%}.fh-toolbar .fh-search{flex:1 !important;width:auto !important}.fh-share-pop{right:auto !important;left:0 !important;width:calc(100vw - 40px) !important;max-width:340px !important}}';

  function injectStyle() {
    var existing = document.getElementById('fh-blog-filter-style');
    if (existing) existing.remove();
    var s = document.createElement('style');
    s.id = 'fh-blog-filter-style';
    s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function norm(s) {
    return (s == null ? '' : String(s)).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function init() {
    injectStyle();
    var grid = document.getElementById('fh-grid');
    if (!grid) return;
    if (!document.querySelector('.fh-pills')) return;
    var searchInput = document.getElementById('fh-search-input');
    var featured = document.querySelector('.fh-featured');

    var allCards = Array.prototype.slice.call(grid.children).filter(function (n) {
      return n.classList && n.classList.contains('fh-card');
    });
    if (!allCards.length) return;

    var searchWrap = searchInput.parentElement;
    var cell;
    if (searchWrap.parentElement && !searchWrap.parentElement.classList.contains('fh-search-cell')) {
      cell = document.createElement('div');
      cell.className = 'fh-search-cell';
      searchWrap.parentElement.insertBefore(cell, searchWrap);
      cell.appendChild(searchWrap);
    } else {
      cell = searchWrap.parentElement;
    }

    var shareBtn = document.createElement('button');
    shareBtn.type = 'button';
    shareBtn.className = 'fh-share-btn';
    shareBtn.setAttribute('aria-label', 'Partager cette sélection');
    shareBtn.title = 'Partager cette sélection';
    shareBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>';
    cell.appendChild(shareBtn);

    var pop = document.createElement('div');
    pop.className = 'fh-share-pop';
    pop.innerHTML = '<h4>Partager cette s\u00e9lection</h4>' +
      '<div class="fh-share-row">' +
        '<input type="text" id="fh-share-url" readonly>' +
        '<button type="button" id="fh-share-copy">Copier</button>' +
      '</div>' +
      '<div class="fh-share-socials">' +
        '<a href="#" data-net="linkedin" target="_blank" rel="noopener noreferrer">' +
          '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14M8.339 18.337v-8.59H5.671v8.59h2.668M7.014 8.567a1.544 1.544 0 1 0 0-3.089 1.544 1.544 0 0 0 0 3.089m11.319 9.77V13.64c0-2.359-1.275-3.456-2.977-3.456-1.371 0-1.987.755-2.328 1.282V9.747h-2.668v8.59h2.668v-4.69c0-.755.142-1.488 1.075-1.488.929 0 .947.864.947 1.535v4.643h2.668z"/></svg>' +
          'LinkedIn</a>' +
        '<a href="#" data-net="twitter" target="_blank" rel="noopener noreferrer">' +
          '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231z"/></svg>' +
          'X</a>' +
        '<a href="#" data-net="whatsapp" target="_blank" rel="noopener noreferrer">' +
          '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M.057 24l1.687-6.163A11.867 11.867 0 0 1 .222 11.79C.225 5.495 5.345.376 11.642.376a11.79 11.79 0 0 1 8.413 3.488 11.823 11.823 0 0 1 3.48 8.401c-.003 6.296-5.123 11.416-11.42 11.416a11.86 11.86 0 0 1-5.59-1.418L.057 24z"/></svg>' +
          'WhatsApp</a>' +
        '<a href="#" data-net="email" target="_blank">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>' +
          'Email</a>' +
      '</div>';
    cell.appendChild(pop);

    var urlField = pop.querySelector('#fh-share-url');
    var copyBtn = pop.querySelector('#fh-share-copy');

    function buildShareUrl(q, cat) {
      var base = location.origin + location.pathname;
      var params = [];
      if (q) params.push('q=' + encodeURIComponent(q));
      if (cat && cat !== 'all') params.push('filter=' + encodeURIComponent(cat));
      return params.length ? base + '?' + params.join('&') : base;
    }
    function updateShareUI(q, cat) {
      var url = buildShareUrl(q, cat);
      urlField.value = url;
      var hasState = !!(q || (cat && cat !== 'all'));
      shareBtn.classList.toggle('is-visible', hasState);
      if (!hasState) pop.classList.remove('is-open');
      var title = 'S\u00e9lection FOODHUB \u00b7 Journal';
      var hint = q ? '\u00ab ' + q + ' \u00bb' : '';
      if (cat && cat !== 'all') hint = (hint ? hint + ' \u00b7 ' : '') + cat;
      var msg = title + (hint ? ' : ' + hint : '');
      var socials = pop.querySelectorAll('.fh-share-socials a');
      socials.forEach(function (a) {
        var net = a.getAttribute('data-net');
        var href = '#';
        if (net === 'linkedin') href = 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(url);
        else if (net === 'twitter') href = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(msg);
        else if (net === 'whatsapp') href = 'https://wa.me/?text=' + encodeURIComponent(msg + ' ' + url);
        else if (net === 'email') href = 'mailto:?subject=' + encodeURIComponent(msg) + '&body=' + encodeURIComponent('Voici la s\u00e9lection FOODHUB : ' + url);
        a.setAttribute('href', href);
      });
    }
    function updateUrl(q, cat) {
      var url = buildShareUrl(q, cat);
      if (location.href !== url) {
        try { history.replaceState(null, '', url); } catch (e) {}
      }
      updateShareUI(q, cat);
    }

    function activeCategory() {
      var p = document.querySelector('.fh-pill.fh-active') || document.querySelector('.fh-pill');
      if (!p) return 'all';
      var c = p.getAttribute('data-filter') || p.getAttribute('data-category');
      return c ? norm(c) : 'all';
    }
    function cardMatchesCategory(card, cat) {
      if (cat === 'all' || !cat) return true;
      var tags = norm(card.getAttribute('data-tags') || '');
      if (!tags) return false;
      var list = tags.split(',').map(function (t) { return t.trim(); });
      return list.indexOf(cat) !== -1;
    }
    function cardMatchesSearch(card, q) {
      if (!q) return true;
      var title = norm(card.getAttribute('data-title') || '');
      var tags = norm(card.getAttribute('data-tags') || '');
      var visible = norm(card.textContent || '');
      return title.indexOf(q) !== -1 || tags.indexOf(q) !== -1 || visible.indexOf(q) !== -1;
    }
    function applyFilter() {
      var cat = activeCategory();
      var q = searchInput ? norm(searchInput.value) : '';
      while (grid.firstChild) grid.removeChild(grid.firstChild);
      var visible = 0;
      for (var i = 0; i < allCards.length; i++) {
        var card = allCards[i];
        if (cardMatchesCategory(card, cat) && cardMatchesSearch(card, q)) {
          grid.appendChild(card);
          visible++;
        }
      }
      if (featured) featured.classList.toggle('fh-hide-during-search', !!(q || (cat && cat !== 'all')));
      renderEmptyState(visible === 0, q, cat);
      updateUrl(q, cat);
    }
    function renderEmptyState(isEmpty, q, cat) {
      var host = grid.parentElement || document.body;
      var msg = host.querySelector('.fh-empty-msg');
      if (isEmpty) {
        if (!msg) {
          msg = document.createElement('div');
          msg.className = 'fh-empty-msg';
          msg.style.cssText = 'text-align:center;padding:48px 20px;color:#888;font-family:Poppins,Inter,system-ui,sans-serif;font-size:14px;line-height:1.6;';
          host.appendChild(msg);
        }
        var hasQ = !!q, hasCat = cat && cat !== 'all';
        if (hasQ && hasCat) msg.textContent = 'Aucun article \u00ab ' + q + ' \u00bb dans cette cat\u00e9gorie. Essaie de cliquer sur \u00ab Tous \u00bb.';
        else if (hasQ) msg.textContent = 'Aucun article ne correspond \u00e0 \u00ab ' + q + ' \u00bb.';
        else msg.textContent = 'Aucun article dans cette cat\u00e9gorie pour le moment.';
        msg.style.display = 'block';
      } else if (msg) {
        msg.style.display = 'none';
      }
    }

    var oldPills = Array.prototype.slice.call(document.querySelectorAll('.fh-pill'));
    oldPills.forEach(function (pill) {
      var clone = pill.cloneNode(true);
      pill.parentNode.replaceChild(clone, pill);
    });
    var newPills = Array.prototype.slice.call(document.querySelectorAll('.fh-pill'));
    newPills.forEach(function (pill) {
      pill.addEventListener('click', function (e) {
        e.preventDefault();
        newPills.forEach(function (p) { p.classList.remove('fh-active'); });
        pill.classList.add('fh-active');
        applyFilter();
      });
    });

    searchInput.setAttribute('placeholder', 'Wagyu, huile d\u0027olive, vinaigre...');
    var oldClear = searchWrap && searchWrap.querySelector('.fh-search-clear');
    if (oldClear) oldClear.remove();
    var clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'fh-search-clear';
    clearBtn.setAttribute('aria-label', 'Effacer la recherche');
    clearBtn.innerHTML = '\u00d7';
    clearBtn.addEventListener('click', function () {
      searchInput.value = '';
      searchInput.focus();
      applyFilter();
      syncClearVisibility();
    });
    searchWrap.appendChild(clearBtn);
    function syncClearVisibility() {
      clearBtn.style.display = searchInput.value ? 'flex' : 'none';
    }
    var t = null;
    function onInput() {
      if (t) clearTimeout(t);
      t = setTimeout(function () { applyFilter(); syncClearVisibility(); }, 100);
    }
    searchInput.addEventListener('input', onInput);
    searchInput.addEventListener('search', onInput);
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        applyFilter();
        syncClearVisibility();
      }
    });

    shareBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      pop.classList.toggle('is-open');
    });
    document.addEventListener('click', function (e) {
      if (!pop.contains(e.target) && e.target !== shareBtn && !shareBtn.contains(e.target)) {
        pop.classList.remove('is-open');
      }
    });
    copyBtn.addEventListener('click', function () {
      var url = urlField.value;
      function showCopied() {
        copyBtn.classList.add('copied');
        copyBtn.textContent = 'Copi\u00e9 \u2713';
        setTimeout(function () { copyBtn.classList.remove('copied'); copyBtn.textContent = 'Copier'; }, 1500);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(showCopied).catch(function(){
          urlField.select();
          try { document.execCommand('copy'); } catch (e) {}
          showCopied();
        });
      } else {
        urlField.select();
        try { document.execCommand('copy'); } catch (e) {}
        showCopied();
      }
    });

    var params = new URLSearchParams(location.search);
    var initialQ = params.get('q');
    var initialFilter = params.get('filter');
    if (initialQ) searchInput.value = initialQ;
    if (initialFilter) {
      var targetFilter = norm(initialFilter);
      newPills.forEach(function (p) {
        var f = p.getAttribute('data-filter') || p.getAttribute('data-category') || '';
        if (norm(f) === targetFilter) {
          newPills.forEach(function (pp) { pp.classList.remove('fh-active'); });
          p.classList.add('fh-active');
        }
      });
    }
    syncClearVisibility();

    var track = document.querySelector('.foodhub-journal');
    if (track && !track.__fhObserved) {
      track.__fhObserved = true;
      var killTransform = function () { if (track.style.transform) track.style.transform = ''; };
      var mo = new MutationObserver(killTransform);
      mo.observe(track, { attributes: true, attributeFilter: ['style'] });
    }

    applyFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
